import {Component, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';

import {FormBuilder, FormGroup} from '@angular/forms';

import {ActivatedRoute} from '@angular/router';

import {ApiService} from '../../api.service';
import {Message, MessageTypes} from '../../message';
import {MessageService} from '../../message.service';

import {CalendarComponent} from '../calendar.component';
import {TagsComponent} from '../../tags/tags.component';
import {MatDatepicker, MAT_DATE_FORMATS, DateAdapter, MAT_DATE_LOCALE} from '@angular/material';

@Component({
    selector: 'app-edit-calendar',
    templateUrl: './edit-calendar.component.html',
    styleUrls: ['./edit-calendar.component.css'],
})
export class EditCalendarComponent implements OnInit {
    @Output() message = new EventEmitter<Message>();
    @ViewChild(MatDatepicker) datepicker: MatDatepicker<Date>;
    @ViewChild(TagsComponent)
    protected tagsComponent: TagsComponent;

    private id: any;
    public calendar: any;
    private editForm: FormGroup;
    title = 'New calendar';
    state;
    submitLabel: string;

    constructor(
        private route: ActivatedRoute,
        private apiService: ApiService,
        public formBuilder: FormBuilder,
        protected calendarComponent: CalendarComponent,
        private messageService: MessageService
    ) {
        this.editForm = this.formBuilder.group({
            id: '', /* der Wert '' ist der Default-Wert */
            title: '',
            duration: '',
            durationunit: '',
            date: '',
            allday: '1',
            repeats: 'no',
            hour: '00',
            minute: '00',
            nrrepititions: 0
        });
        this.calendar = {
            id: 0,
            title: '',
            duration: '',
            durationunit: '',
            date: new Date(),
            tags: [],
            hour: '00',
            minute: '00',
            allday: '1',
            repeats: 'no',
            nrrepititions: 0
        };
    }

    ngOnInit() {
        const id = this.route.snapshot.paramMap.get('id');
        this.state = '';
        if (id) {
            this.title = 'Edit calendar';
            this.id = id;
            this.state = 'loading';
            this.submitLabel = 'update';
            this.loadCalendar();
        } else {
            this.submitLabel = 'save';
        }
        // console.log('getting calendar with id', this.id);
    }

    loadCalendar() {
        this.submitLabel = 'loading';
        this.apiService.getById('calendar', this.id).subscribe(
            (value) => {
                this.calendar = value;
                this.tagsComponent.tags = this.calendar.tags;
                this.state = '';
                this.submitLabel = 'update';
                const time = value['time'].split(':');
                this.calendar.hour = time[0];
                this.calendar.minute = time[1];
            }, (error) => {
                this.state = '';
                this.submitLabel = 'update';
            }
        );
    }

    submit() {
        this.calendar.tags = this.tagsComponent.tags;
        this.calendar.time = this.calendar.hour + ':' + this.calendar.minute;
        this.state = 'saving';
        this.submitLabel = 'saving';
        console.log(document.querySelector('input[name="calendarpicker"]'));

        // workaround because manually entering values doesn't seem to work well with material date picker and German locale
        const dateVal = document.querySelector('input[name="calendarpicker"]')['value'].split('.');
        this.calendar.date = new Date(parseInt(dateVal[2], 10), parseInt(dateVal[1], 10) - 1, parseInt(dateVal[0], 10));
        if (this.id) {
            this.apiService.put('calendar', this.id, this.calendar)
                .subscribe(
                    (value: any) => {
                        this.messageService.setMessage('Calendar got updated', MessageTypes.Success);
                        this.state = '';
                        this.submitLabel = 'update';
                    }, (err) => {
                        this.messageService.setMessage('An error occurred - the calendar didn`t get updated', MessageTypes.Error);
                        this.state = '';
                        this.submitLabel = 'update';
                    });
        } else {
            this.apiService.post('calendar', this.calendar)
                .subscribe(
                    (value: any) => {
                        this.messageService.setMessage('Calendar added', MessageTypes.Success);
                        this.calendarComponent.calendarAdded();
                        this.state = '';
                        this.submitLabel = 'save';
                    }, (err) => {
                        this.messageService.setMessage('Failed to save calendar', MessageTypes.Error);
                        this.state = '';
                        this.submitLabel = 'save';
                    }
                );
        }
    }
    zeroFill(event) {
        const target = event.target;
        let val = target.value;
        if (val.length === 1) {
            val = '0' + val;
        }
        target.value = val;
    }
    checkValue(event) {
        const target = event.target;
        console.log(target);
        let val = target.value;
        val = val.replace(/[^0-9]/, '');
        val = parseInt(val, 10);
        if (isNaN(val)) {
            val = 0;
        }
        if (val < target.dataset.min) {
            val = target.dataset.min;
        }
        if (val > target.dataset.max) {
            val = target.dataset.max;
        }
        val = String(val);
        target.value = val;
    }

}



// WEBPACK FOOTER //
// ./src/app/calendar/edit-calendar/edit-calendar.component.ts